import { commonApi } from "../../app/services/commonApi";

/** Enums */
import { MasterDataCacheURL } from "../../enums/CacheURL";

export const PreloadDropdownData = (dispatch, force = false) => {

  Object.values(MasterDataCacheURL).forEach(path => {
    dispatch(
      commonApi.endpoints.getDropdownData.initiate(
        { url: path },
        { forceRefetch: force }
      )
    );
  });
};